import './NBALogo.css'

const NBALogo = (props) => {

    return (
        <div onClick={props.onClick} className="appbar-nba-logo appbar-nba-logo-rightMargin"></div>
    )
}

export default NBALogo;